// src/redux/Types.js
export const ADD_FACULTY_REVIEWED = 'ADD_FACULTY_REVIEWED';
export const CHECK_IF_EXIST_IN_FACULTY = 'CHECK_IF_EXIST_IN_FACULTY';
export const ADD_REPORTED_REVIEW = 'ADD_REPORTED_REVIEW'; // New action type
export const SET_NOTICE_ALREADY_SHOWN = 'SET_NOTICE_ALREADY_SHOWN'; // New action type
